var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.21459 5.5L9.99792 6.28333L2.43126 13.8333H1.66459V13.0667L9.21459 5.5ZM12.2146 0.5C12.0063 0.5 11.7896 0.583333 11.6313 0.741667L10.1063 2.26667L13.2313 5.39167L14.7563 3.86667C15.0813 3.54167 15.0813 3 14.7563 2.69167L12.8063 0.741667C12.6396 0.575 12.4313 0.5 12.2146 0.5ZM9.21459 3.15833L-0.0020752 12.375V15.5H3.12292L12.3396 6.28333L9.21459 3.15833Z",
    fill: "#009ACE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.9f45aa570d1a6a77796f2bf6e47368f0.svg";
export { ForwardRef as ReactComponent };